



















































import { Form } from 'element-ui';
import { Component, Vue } from 'vue-property-decorator';
import { requiredOnChange } from '@/shared/validation/rule';
import { ISignUpRequest, ILoginRequest } from '../../shared/models';

@Component({
  components: {},
})
export default class Home extends Vue {
  protected signUpForm: ISignUpRequest = {
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    firstName: '',
    lastName: '',
  };

  protected rules = {
    email: [requiredOnChange],
    password: [requiredOnChange],
    confirmPassword: [requiredOnChange],
    phone: [requiredOnChange],
    firstName: [requiredOnChange],
    lastName: [requiredOnChange],
  };

  private submitForm() {
    const vm = this;
    (this.$refs.signUpForm as Form).validate(async (valid) => {
      if (valid) {
        const loginInfo: ILoginRequest = await vm.$store.dispatch('signup', this.signUpForm);
        if (loginInfo.email) {
          const loginSuccess = await vm.$store.dispatch('login', loginInfo);
          if (loginSuccess) {
            vm.$notify.success('Đăng nhập thành công');
            vm.$router.push({
              name: 'stats',
            });
          } else vm.$notify.error('Đăng nhập thất bại');
        }
      }
    });
  }
}
